import * as React from "react";
import { observable, computed, action } from "mobx"
import { observer, inject } from "mobx-react";
import { Link } from "../General/Link";
import { NotificationStore } from "../Stores/NotificationStore";
import * as DocumentManagement from "../DocumentManagement";
import { Urls } from "../Urls";
import { CollectionStoreImpl } from "../Stores/CollectionStore";
import { DialogStore, DialogResult } from "../Stores/DialogStore";
import * as Utilities from "../Utilities";
import { Strings } from "../Stores/StringsStore";
import { RemoveQuery } from "../Shared";
import { newGuid } from "../Utilities";
import { AppStore } from "../Stores/AppStore";

interface ICollectionDocumentsEditProps {
    collection: DocumentManagement.CollectionDetails;
    store?: CollectionStoreImpl;
    testId?: string;
    isDocumentGroupSaved?: boolean;
}

@inject('store')
@observer
export class CollectionDocumentsEdit extends React.Component<ICollectionDocumentsEditProps, {}> {

    store: CollectionStoreImpl;

    @observable collectionId = "";

    componentWillMount() {
        this.store = this.props.store;
        this.store.handleDocumentsDelete = this.handleDocumentsDelete;
    }

    componentDidMount() {
        if (this.props.collection.guid)
            this.getModel();
    }

    componentDidUpdate() {
        if ((this.collectionId != this.props.collection.guid) && this.props.collection.guid) {
            this.getModel();
        }
    }

    getModel() {
        let query = new DocumentManagement.CollectionDocumentQuery();
        query.collectionId = this.props.collection.guid;
        DocumentManagement.queryCollectionDocumentsAsync(query).then(model => {
            this.collectionId = query.collectionId;
            this.store.documentInfoList.replace(model);
            NotificationStore.clearMessage();
        }).catch(error => {
            DialogStore.showError(Strings.general.errorDialogTitle, error);
        });
    }

    @computed get documentsListClass(): string {
        return this.props.store.documentSelectionMode ? "list-advanced is--selection" : "list-advanced";
    }

    @action handleClickItem = (selectedDocument: DocumentManagement.DocumentInfo, e: React.MouseEvent<any>) => {
        if (this.props.store.documentSelectionMode) {
            let doc = this.props.store.selectedDocuments.find(d => d.guid === selectedDocument.guid);
            if (doc) {
                this.props.store.selectedDocuments.remove(doc);
            }
            else {
                this.props.store.selectedDocuments.push(selectedDocument);
            }
            e.preventDefault();
        }
    }

    @action handleDocumentsDelete = () => {
        let deleteTitle = this.props.store.selectedDocuments.length > 1 ? Strings.documentManagement.collectionEdit.deleteMultipleDocumentsDialogTitle : Utilities.format(Strings.general.dialogDeleteTitle, this.props.store.selectedDocuments[0].name);
        let deleteText = this.props.store.selectedDocuments.length > 1 ? Strings.documentManagement.collectionEdit.deleteMultipleDocumentsDialogText : Utilities.format(Strings.general.dialogDeleteText, this.props.store.selectedDocuments[0].name);
        DialogStore.show(deleteTitle, deleteText).then(result => {
            if (result == DialogResult.Yes) {
                AppStore.isBusy = true;
                let selectedDocumentsRemoveQuery: RemoveQuery[] = [];
                this.props.store.selectedDocuments.map(selectedDocument => {
                    selectedDocumentsRemoveQuery.push({ guid: selectedDocument.guid, lastModified: selectedDocument.lastModified });
                });
                DocumentManagement.removeDocumentsAsync(selectedDocumentsRemoveQuery).then(status => {
                    AppStore.isBusy = false;
                    NotificationStore.showSuccessMessage(Strings.general.deleteSuccessMessage);
                    this.props.store.selectedDocuments.clear();
                    this.props.store.documentSelectionMode = false;
                    this.getModel();
                }).catch(error => {
                    AppStore.isBusy = false;
                    DialogStore.showError(Strings.general.errorDialogTitle, error);
                });
            }
        });
    }

    handleNoDocumentsSpanClick = () => {
        AppStore.keepOnPage(`${Urls.collections}/${this.props.store.collection.guid}/documents/${newGuid()}`, true, null);
    }

    render() {
        return this.store.documentInfoList.length > 0 ? <div className={this.documentsListClass} data-test-id={this.props.testId}>
            <table>
                <tbody>
                    {
                        this.store.documentInfoList.map(doc => {
                            let isSelected = this.props.store.documentSelectionMode && this.props.store.selectedDocuments.some(item => doc.guid === item.guid)
                            let collectionLink = `${Urls.collections}/${this.props.collection.guid}/documents/${doc.guid}`;
                            if (this.store.asideTreeViewStore && this.store.asideTreeViewStore.treePath) {
                                collectionLink = `${collectionLink}?treepath=${this.store.asideTreeViewStore.treePath.filter(function (e) { return e }).join(",")}`;
                            }

                            return <tr key={doc.guid} >

                                <td className="check-cell">

                                    <span className="list-simple__selection" onClick={this.handleClickItem.bind(this, doc)}>
                                        <label className="custom-radiocheck">
                                            <input type="checkbox" checked={isSelected} />
                                            <span className="checkbox-style"></span>
                                        </label>
                                    </span>

                                </td>

                                <td>
                                    <Link onClick={this.handleClickItem.bind(this, doc)} className="link-document is--basic-link" to={collectionLink} testId={doc.name}>
                                        <span>
                                            {doc.name}
                                        </span>

                                    </Link>
                                </td>
                            </tr>;
                        })
                    }
                </tbody>
            </table>
        </div> :
            !this.props.isDocumentGroupSaved ?
                <div className="inside__note is--clickable-note" onClick={this.handleNoDocumentsSpanClick} >
                    <span>
                        {Strings.documentManagement.collectionEdit.collectionEmptyDocumentResultText}
                    </span>
                </div> : null;

    }
}
